import React from "react";

const RANK_COLORS = ["#6366F1", "#F59E0B", "#10B981", "#EF4444", "#8B5CF6"];

/**
 * Reusable TopDistributorsList component.
 *
 * Props:
 *  - distributors: Array<{
 *      name: string,
 *      subtitle?: string,       — e.g. "32 sales"
 *      amount: string,          — e.g. "₹1766" or commission string
 *      status?: string,         — e.g. "Commited"
 *      statusColor?: string     — hex for status badge bg
 *    }>
 *  - title?: string
 */
const TopDistributorsList = ({ distributors = [], title = "Top Distributors", monthInfo }) => {
    return (
        <div className="dash-card" style={{ height: "100%" }}>
            <div className="dash-card-header flex justify-between items-start">
                <div>
                    <h3 className="dash-section-title">{title}</h3>
                    <p className="dash-section-sub">Highest performing partners</p>
                </div>
                {monthInfo && (
                    <span className="text-[10px] text-gray-400 font-medium bg-gray-50 px-2 py-1 rounded-md border border-gray-100">
                        {monthInfo}
                    </span>
                )}
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                {distributors.map((d, i) => (
                    <div key={i} className="top-dist-row">
                        {/* Rank Badge */}
                        <div
                            className="top-dist-rank"
                            style={{ backgroundColor: RANK_COLORS[i % RANK_COLORS.length] }}
                        >
                            {String(i + 1).padStart(2, "0")}
                        </div>

                        {/* Name + Subtitle */}
                        <div className="top-dist-info">
                            <span className="top-dist-name">{d.name}</span>
                            {d.subtitle && (
                                <span className="top-dist-subtitle">{d.subtitle}</span>
                            )}
                        </div>

                        {/* Amount + Status */}
                        <div className="top-dist-right">
                            <span className="top-dist-amount">{d.amount}</span>
                            {d.status && (
                                <span
                                    className="dash-status-badge"
                                    style={{
                                        backgroundColor: d.statusColor || "#D1FAE5",
                                        color: d.statusColor ? "#fff" : "#065F46",
                                        fontSize: "0.65rem",
                                    }}
                                >
                                    {d.status}
                                </span>
                            )}
                        </div>
                    </div>
                ))}

                {distributors.length === 0 && (
                    <p style={{ color: "#9CA3AF", fontSize: "0.82rem", textAlign: "center", padding: "16px 0" }}>
                        No data available
                    </p>
                )}
            </div>
        </div>
    );
};

export default TopDistributorsList;
